var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: "导入物模型",
            "close-on-click-modal": "",
            modal: true,
            width: 1000,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c("div", { staticClass: "model-content" }, [
            _c("p", [_vm._v("请导入物模型TSL完整版JSON数据")]),
            _c("div", { staticClass: "json-content" }, [
              _c("div", {
                class: `input-json ${_vm.isError ? "is-error" : ""}`,
                attrs: { contenteditable: "" },
                on: { keyup: _vm.handleChange },
              }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }